import { useCallback, useMemo, useState } from 'react';
import { ALL_STATUS_OPTIONS, UNASSIGNED_AGENT } from '../utils';
import { getAgentsByEnv } from '../components/ApproverTaskTable/components/ChangeApproverTask/utils';

type SortOrder = 'asc' | 'desc';

export const useApproverTaskFilters = (data: any[], country: 'MX' | 'CO') => {
  const [filters, setFilters] = useState<{ agent: string[]; status: string[] }>(
    {
      agent: [],
      status: ['pending'],
    }
  );

  const [sortOrder, setSortOrder] = useState<SortOrder>('asc');

  const handleFilterChange = useCallback(
    (key: 'agent' | 'status', selected: string[]) => {
      setFilters(prev => ({ ...prev, [key]: selected }));
    },
    []
  );

  const toggleSortOrder = () => {
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const filteredData = useMemo(() => {
    const filtered = data.filter(row => {
      // La selección de agentes es literal: lo que está marcado en el dropdown
      // es exactamente lo que se muestra. Sin marcas, no hay filas.
      const matchAgent = filters.agent.includes(row.agent || UNASSIGNED_AGENT);
      const matchStatus =
        filters.status.length === 0 || filters.status.includes(row.status);
      return matchAgent && matchStatus;
    });

    return [...filtered].sort((a, b) => {
      const aTime = new Date(a.date).getTime();
      const bTime = new Date(b.date).getTime();
      return sortOrder === 'asc' ? aTime - bTime : bTime - aTime;
    });
  }, [data, filters, sortOrder]);

  const agentOptions = useMemo(() => {
    const agents = getAgentsByEnv(country);
    return [
      ...agents.map(agent => ({ label: agent, value: agent })),
      // Las tareas sin agente asignado se guardan con `agent` vacío; sin esta
      // opción quedarían fuera de cualquier selección y serían invisibles.
      { label: UNASSIGNED_AGENT, value: UNASSIGNED_AGENT },
    ];
  }, [country]);

  const statusOptions = ALL_STATUS_OPTIONS;

  return {
    filters,
    filteredData,
    agentOptions,
    statusOptions,
    handleFilterChange,
    toggleSortOrder,
    sortOrder,
  };
};
